<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="app-main-content">
    <fcl-real-list config-module="221301" />
  </div>
</template>

<script>
import fclRealList from '@/views/cargo/v0/Price/components/list/fclRealList'

export default {
  name: 'PriceFCLReal',
  components: {
    fclRealList // 平台版付款申请查询列表
  }
}
</script>

<style lang="scss">
</style>
